export default "__VITE_ASSET__b574dabc__"